import React, { useContext, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { GlobalContext } from '../../GlobalContext';
import Loading from '../loading/Loading';
import { isAuthenticated as checkAuth, buildUrlWithReturnUrl } from '../../utils/auth';

const ProtectedRoute = ({ children }) => {
  const { userData, isLoading, apiError } = useContext(GlobalContext);
  const location = useLocation();
  const [authStatus, setAuthStatus] = useState(null);

  useEffect(() => {
    const authResult = checkAuth(userData, isLoading, apiError);
    setAuthStatus(authResult);
  }, [userData, isLoading, apiError]);

  // Show loading while determining authentication status
  if (authStatus === null) {
    return <Loading />;
  }

  // If not authenticated, redirect to login with return URL
  if (!authStatus) {
    const returnUrl = location.pathname + location.search;
    const loginUrl = buildUrlWithReturnUrl('/login', returnUrl);
    return <Navigate to={loginUrl} replace />;
  }

  // If authenticated, render the protected component
  return children;
};

export default ProtectedRoute;
